const Eye = ({ ...props }) => {
    return (
        <svg width="20px" height="11px" viewBox="0 0 20 11" {...props}>
            <g
                id="Checkout"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity="currentOpacity"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="Checkout---Sign-In---Existing-Account---Desktop"
                    transform="translate(-591.000000, -469.000000)"
                    stroke="currentColor"
                >
                    <g
                        id="Street-Copy-3"
                        transform="translate(188.000000, 457.000000)"
                    >
                        <g id="Field">
                            <g
                                id="eye"
                                transform="translate(404.000000, 12.000000)"
                            >
                                <path
                                    d="M11.1428571,5.5 C11.1428571,6.78189286 10.1832857,7.82142857 9,7.82142857 C7.81671429,7.82142857 6.85714286,6.78189286 6.85714286,5.5 C6.85714286,4.21810714 7.81671429,3.17857143 9,3.17857143 C10.1832857,3.17857143 11.1428571,4.21810714 11.1428571,5.5 L11.1428571,5.5 Z"
                                    id="Stroke-92"
                                />
                                <path
                                    d="M0,5.52758789 C1.28442857,2.84549158 5.60442857,0.708007812 9.01628571,0.708007812 C12.4285714,0.708007812 16.6752857,2.80968898 18,5.46045803"
                                    id="Stroke-94"
                                />
                                <path
                                    d="M0,5.52758789 C1.28442857,8.2096842 5.60442857,10.347168 9.01628571,10.347168 C12.4285714,10.347168 16.6752857,8.2454868 18,5.59471776"
                                    id="Stroke-96"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Eye
